<template>
  <div class="threat-canvas-controls">
    <!-- File controls group -->
    <div class="threat-canvas-btn-group-wrapper">
      <div class="threat-canvas-controls__label">
        {{ $t('ctc.controls.label.file') }}
      </div>
      <div class="threat-canvas-controls__btn-toggle-sim">
        <v-btn text @click="handleClick('save')" :title="$t('ctc.controls.hint.save')">
          <v-icon>save</v-icon>
        </v-btn>
        <v-btn text @click="handleClick('load')" :title="$t('ctc.controls.hint.load')">
          <v-icon>file_upload</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Node controls group -->
    <div class="threat-canvas-btn-group-wrapper">
      <div class="threat-canvas-controls__label">
        {{ $t('ctc.controls.label.node') }}
      </div>
      <div class="threat-canvas-controls__btn-toggle-sim">
        <v-btn text @click="handleClick('add-node')" :title="$t('ctc.controls.hint.add')">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn text
               @click="handleClick('add-link')"
               :disabled="!isNodeSelected"
               :title="$t('ctc.controls.hint.add.link')">
          <v-icon>add_link</v-icon>
        </v-btn>
        <v-btn text
               @click="handleClick('delete')"
               :disabled="!isSelected"
               :title="$t('ctc.controls.hint.delete')">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </div>
    <!-- Chart controls group -->
    <div class="threat-canvas-btn-group-wrapper">
      <div class="threat-canvas-controls__label">
        {{ $t('ctc.controls.label.chart') }}
      </div>
      <div class="threat-canvas-controls__btn-toggle-sim">
        <v-btn text @click="handleClick('order')" :title="$t('ctc.controls.hint.order')">
          <v-icon>account_tree</v-icon>
        </v-btn>
        <v-btn text @click="handleClick('reset-view')" :title="$t('ctc.controls.hint.resetView')">
          <v-icon>crop_free</v-icon>
        </v-btn>
        <v-btn text @click="handleClick('zoom-in')" :title="$t('ctc.controls.hint.zoomIn')">
          <v-icon>zoom_in</v-icon>
        </v-btn>
        <v-btn text @click="handleClick('zoom-out')" :title="$t('ctc.controls.hint.zoomOut')">
          <v-icon>zoom_out</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Grid controls group -->
    <div class="threat-canvas-btn-group-wrapper">
      <div class="threat-canvas-controls__label">
        {{ $t('ctc.controls.label.grid') }}
      </div>
      <div class="threat-canvas-controls__btn-toggle-sim">
        <v-btn text @click="toggleGrid" :title="$t('ctc.controls.hint.toggleGrid')">
          <v-icon :class="{ 'grid-active': isGridOn }">grid_on</v-icon>
        </v-btn>
        <v-btn text
               :disabled="!isGridOn"
               @click="handleClick('grid-zoom-out')"
               :title="$t('ctc.controls.hint.gridZoomOut')">
          <v-icon>grid_3x3</v-icon>
        </v-btn>
        <v-btn text
               :disabled="!isGridOn"
               @click="handleClick('grid-zoom-in')"
               :title="$t('ctc.controls.hint.gridZoomIn')">
          <v-icon>grid_4x4</v-icon>
        </v-btn>
        <v-btn text
               :disabled="!isGridOn"
               @click="handleClick('reset-grid')"
               :title="$t('ctc.controls.hint.resetGrid')">
          <v-icon>crop_free</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThreatCanvasControls',
  props: {
    isGridOn: {
      type: Boolean,
      default: false,
    },
    isNodeSelected: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    toggleGrid() {
      this.$emit('threat-canvas-control-clicked', 'grid-on-off', !this.isGridOn);
    },
    handleClick(action) {
      this.$emit('threat-canvas-control-clicked', action);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.threat-canvas-controls {
  display: flex;
  margin: rem(15) 0;
  justify-content: center;
  flex-grow: 1;
  pointer-events: none;

  &__label {
    color: var(--text-tertiary);
    font-family: $font-family-regular;
    font-size: rem(12);
    letter-spacing: 1.1px;
    line-height: rem(14);
    margin-bottom: rem(5);
    text-transform: uppercase;
  }

  &__btn-toggle-sim {
    display: inline-flex;
    border: 1px solid var(--border-primary);
    border-radius: $radius-md;
    overflow: hidden;
    color: var(--text-primary);
    background: transparent;

    ::v-deep .v-btn {
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      background: transparent !important;
    }
    ::v-deep .v-btn:not(:last-child) {
      border-right: 1px solid var(--border-primary);
    }
    ::v-deep .v-icon {
      color: var(--text-primary);
    }

    ::v-deep .v-icon.grid-active {
      color: var(--brand-primary);
    }
  }
}

.threat-canvas-btn-group-wrapper {
  display: flex;
  flex-direction: column;
  margin-right: rem(15);
  pointer-events: auto;
  position: relative;
  z-index: 1;
}
</style>
